import { SET_PAGINATION } from '../../Redux/ActionName/ActionName';
import { useDispatch, useSelector } from 'react-redux';
import MonPagination from './MonPagination';
import { colors } from '../../Constant/Color';
import { useState, useEffect } from 'react';

function MongoosePagination() {
  const dispatch = useDispatch();
  const TableDataReducer = useSelector((state) => state.TableReducer);
  const [isMobile, setIsMobile] = useState(false);

  console.log('TableDataReducer------', TableDataReducer);

  // Check if mobile screen
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 640);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Extract pagination data from reducer
  const { page, limit, total } = TableDataReducer.pagination;

  // Handle page change
  const handlePageChange = (newPage) => {
    dispatch({
      type: SET_PAGINATION,
      value: {
        ...TableDataReducer.pagination,
        page: newPage
      }
    });
  };

  const handleLimitChange = (newLimit) => {
    dispatch({
      type: SET_PAGINATION,
      value: {
        ...TableDataReducer.pagination,
        limit: newLimit,
        page: 1 // Reset to first page when changing limit
      }
    });
  };

  // Limit options
  const limitOptions = [10, 20, 50, 100];

  return (
    <div className="flex flex-col sm:flex-row justify-between items-center py-5 gap-3 sm:gap-4 w-full">

      <div className="flex items-center gap-2 w-full sm:w-auto justify-center sm:justify-start">
        <span className="text-sm whitespace-nowrap" style={{ color: colors.TEXT_SECONDARY }}>Show:</span>
        <div className="relative">
          <select
            value={limit}
            onChange={(e) => handleLimitChange(parseInt(e.target.value))}
            className="border rounded px-3 py-1 pr-8 text-sm focus:outline-none focus:ring-2 appearance-none cursor-pointer"
            style={{
              borderColor: colors.BORDER_GRAY,
              backgroundColor: colors.BG_WHITE,
              color: colors.TEXT_PRIMARY,
            }}
            onFocus={(e) => e.target.style.borderColor = colors.PRIMARY}
            onBlur={(e) => e.target.style.borderColor = colors.BORDER_GRAY}
          >
            {limitOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="overflow-x-auto w-full sm:w-auto flex justify-center sm:justify-end">
        <MonPagination
          total={total}
          outline={false}
          defaultCurrent={1}
          current={page}
          onChange={handlePageChange}
          pageSize={limit}
          variant="solid"
          color="primary"
          showLessItems={isMobile}
        />
      </div>

    </div>
  );
}

export default MongoosePagination;
